import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.617 4.999a.85.85 0 011.202 0l3.182 3.182a.85.85 0 010 1.202l-3.182 3.182a.85.85 0 01-1.202-1.202l1.73-1.731H1.4a.85.85 0 010-1.7h12.948l-1.731-1.731a.85.85 0 010-1.202z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol